var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalTest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lab_work",
    clipPath: "url(#clip0_1232_23553)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "test_tube_fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.667 1.33203C11.0352 1.33203 11.3337 1.63051 11.3337 1.9987C11.3337 2.36688 11.0352 2.66536 10.667 2.66536V11.9987C10.667 13.4714 9.47306 14.6654 8.00033 14.6654C6.52757 14.6654 5.33366 13.4714 5.33366 11.9987V2.66536C4.96547 2.66536 4.66699 2.36688 4.66699 1.9987C4.66699 1.63051 4.96547 1.33203 5.33366 1.33203H10.667ZM9.33366 9.9987H8.00033C7.63213 9.9987 7.33366 10.2972 7.33366 10.6654C7.33366 11.0336 7.63213 11.332 8.00033 11.332H9.33366V9.9987ZM9.33366 7.33203H8.00033C7.63213 7.33203 7.33366 7.6305 7.33366 7.9987C7.33366 8.3406 7.59101 8.62237 7.92258 8.66088L8.00033 8.66536H9.33366V7.33203ZM9.33366 4.66536H8.00033C7.63213 4.66536 7.33366 4.96384 7.33366 5.33203C7.33366 5.70022 7.63213 5.9987 8.00033 5.9987H9.33366V4.66536Z",
    fill: "#82DED9"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1232_23553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalTest);
export default __webpack_public_path__ + "static/media/medical-test.e947ff43fa8155096279c0aa7603ac03.svg";
export { ForwardRef as ReactComponent };